export default __webpack_public_path__ + "static/media/herringbone-pattern-option.02ec7f9a.svg";